'use client'

import { styled } from 'styled-components'

import { Button } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

export const SectionContainer = styled.div`
  border-top: 0.0625rem solid ${Colors.Semantic.Neutral.medium_grey};
  padding-top: 1rem;
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 1rem;
`

export const SectionTitle = styled.h2`
  ${Typography.Title3};
  color: ${Colors.Semantic.Neutral.black};
  margin: 0;
`

export const ChipsRow = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 1rem;

  &:empty {
    display: none;
  }
`

export const ShowAllCard = styled.div`
  background: ${Colors.Semantic.Neutral.white};
  border: 0.0625rem solid ${Colors.Semantic.BStock.default.lightBackground};
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: 0 0.75rem;
  min-width: 14.25rem;
  width: 100%;
  align-self: stretch;
  min-height: 28rem;
`

export const ShowAllCardText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0.625rem 0;
  gap: 0.25rem;
`

export const ShowAllCardTitle = styled.p`
  ${Typography.Title3};
  color: ${Colors.Semantic.Neutral.black};
  margin: 0;
`

export const ShowAllCardSubtitle = styled.p`
  ${Typography.Body3};
  color: ${Colors.Semantic.Neutral.dark_grey};
  margin: 0;
`

export const ShowAllButton = styled(Button)`
  white-space: nowrap;
`
